var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageHotZy"},[_c('h3',[_vm._v("热门专业")]),_vm._v(" "),_c('dl',_vm._l((_vm.rmzyList),function(i){return _c('dd',{key:i.ID},[_c('router-link',{attrs:{"to":i.Url}},[_c('i',{style:('background-image:url('+i.Cover+')')}),_vm._v(" "),_c('p',[_c('span',[_vm._v(_vm._s(i.Title))])])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c5392a0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rmzy.vue
// module id = null
// module chunks = 